module.exports = __webpack_public_path__ + "img/3c.d6dabd68.svg";